<template lang="html">
  <div class="slide">
    <svg class="canvas" ref="scene" viewBox="0 0 4175 3006">
      <rect id="Frame" x="0" y="0" width="4175" height="3006" />
      <g ref="main" transform="translate(399 88)">
        <ImageLazy
          width="1689" height="2830"
          :srcs="[
            `${publicPath}scenes/lowrey/main-q80-w500.jpg`,
            `${publicPath}scenes/lowrey/main.jpg`
          ]" />
      </g>
    </svg>
    <SceneDialogue
      ref="dialogue"
      :width="0.33"
      :bg="`rgba(30,30,30,0.9)`"
      :styles="{color: `white`}"
      :tx="0.88" :ty="0.5">
      While working with the expedition, Max made a friend named Lloyd Lowrey. The
      two of them talked about what Max called “Indian Science,” and about how
      some study the moon and the stars to predict the seasons.<br><br>
      He told him of Diné who went to Skeleton Mesa every four years to gather
      piñon nuts which they could then sell for fifteen dollars a sack. He
      told Lowrey Diné legends, and showed him Paiute Canyon. He explained how
      we plant peach and apricot trees from pits. Our family always raised
      good fruit trees.<br><br>
      He also told him of when the U.S. government passed the 1933 Navajo
      Livestock Reduction Act, where they cut our herds. Only paying us ten
      dollars per animal.
    </SceneDialogue>
    <SceneAudio ref="scene-audio" :src="`${publicPath}scenes/lowrey/audio-charlie-navajo.mp3`" />
  </div>
</template>

<script>
import Template from "./Template.vue"
import SceneDialogue from "../SceneDialogue"
import {TimelineLite, TweenLite} from "gsap"

export default {
  extends: Template,
  mounted() {
    const main = this.$refs["main"]
    const d = this.$refs["dialogue"].$el
    TweenLite.set(main, {opacity: 0})
    TweenLite.set(d, {opacity: 0})

    // this.tl = new TimelineLite({paused: true})
    this.tl.add(TweenLite.to(main, 1, {opacity: 1}), 0.5)
    this.tl.add(TweenLite.to(d, 1, {opacity: 1}), "-=0.5")
  },
  methods: {
    enter() { this.tl.play() }
  },
  components: {
    SceneDialogue,
  }
}
</script>

<style lang="css" scoped>
</style>
